// src/stores/mentorStore.ts
import { create } from "zustand";

export interface Mentor {
  id: string;
  name: string;
  email: string;
  profession: string[];
  dateAdded: string;
  lastConnected: string;
  image: string;
}

interface MentorStore {
  mentors: Mentor[];
  loading: boolean;
  modal: {
    isOpen: boolean;
  };
  setLoading: (loading: boolean) => void;
  setMentors: (mentors: Mentor[]) => void;
  addMentor: (mentor: Mentor) => void;
  clearMentors: () => void;
  openModal: () => void;
  closeModal: () => void;
}

export const useMentorStore = create<MentorStore>((set) => ({
  mentors: [],
  loading: false,
  modal: {
    isOpen: false,
  },
  setLoading: (loading) => set({ loading }),
  setMentors: (mentors) => set({ mentors }),
  addMentor: (mentor) =>
    set((state) => ({
      mentors: [mentor, ...state.mentors],
    })),
  clearMentors: () => set({ mentors: [] }),
  openModal: () => set(() => ({ modal: { isOpen: true } })),
  closeModal: () => set(() => ({ modal: { isOpen: false } })),
}));
